'use client';

import type { ReactNode } from 'react';
import { HStack } from '@terra/ui-styled-system';
import { MetaDefault } from '../../../../../components/typography';
import { EmailInboxCard } from '../../../../artifacts/email/EmailInboxArtifact';
import { parseEmailInboxPayload } from '../../../../artifacts/email/email-inbox-payload';
import type { CardRenderContext } from '../../tool-config-types';

export const renderEmailInboxCard = (ctx: CardRenderContext): ReactNode => {
  const payload = parseEmailInboxPayload(ctx.toolCallData.output);

  if (!payload) {
    return (
      <HStack w="full" gap={1.5} alignItems="center" py={1} borderRadius="sm">
        <MetaDefault color="fg.muted">{ctx.toolName}</MetaDefault>
      </HStack>
    );
  }

  return <EmailInboxCard payload={payload} />;
};
